<template>
  <div class="optionBut">
    <el-popover
      placement="bottom-start"
      trigger="hover"
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          gap: 10px;
        "
      >
        <el-button
          v-permit:remove="'btn:payableManagement:payableCollection:InitiationPayment'" type="warning" size="small"
          :disabled="isPayBut"
          @click="openPayDialog"
        >{{ $i18n.t('basicData.发起付款') }}</el-button>
        <el-button
          v-permit:remove="'btn:payableManagement:payableCollection:EnquiryResults'" type="primary" size="small"
          :disabled="isResults"
          style="margin: 0"
          @click="asyncApiSitePayableQuirePay"
        >{{ $i18n.t('basicData.查询结果') }}</el-button>
      </div>
      <!-- 付款 -->
      <el-button
        v-if="isShowBut" slot="reference" type="primary"
        size="small"
      >{{ $i18n.t('ClaimsManagement.Payment') }}（Bradesco）</el-button>
    </el-popover>

    <!-- 发起付款 弹窗 -->
    <el-dialog
      :title="`${$i18n.t('ClaimsManagement.Payment')}-Bradesco`"
      :visible.sync="isPayDialog"
      :loading="isLoading"
      width="500px"
    >
      <el-form label-width="150px">
        <!-- 付款主体 -->
        <el-form-item :label="$i18n.t('receivablePayable.TheNameOfThePaymentEntity')">
          <span>{{ payForm.providerName }}</span>
        </el-form-item>

        <!-- 付款总金额 -->
        <el-form-item :label="$i18n.t('basicData.付款总金额')">
          <span>{{ payForm.billFee }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isPayDialog = false">{{ $i18n.t('GlobalSetObj.cancel') }}</el-button>
        <!-- 确定 -->
        <el-button type="primary" @click="paySumbit">{{ $i18n.t('GlobalSetObj.determine') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { PAYABLE_STATUS } from '@/views/finance/payableManage/payableCollection/enums.js';
import { apiSitePayablePay, apiSitePayableQuirePay } from '@/api/finance/payableCollection.js';

// 付款单状态为“待核付0、付款失败4、部分付款2”的单
const PAY_STATUS = [
  PAYABLE_STATUS['0'].value, // 待核付
  PAYABLE_STATUS['4'].value, // 付款失败
  PAYABLE_STATUS['2'].value // 部分核付
];

export default {
  name: '',

  props: {
    // 勾选选中的值
    selectData: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      // 发起付款
      payForm: {
        id: 0,
        providerName: '', // 付款主体
        billFee: 0 // 实际收款金额
      },
      isPayDialog: false, // 弹窗显示/隐藏
      isLoading: false, // Loading

      isShowBut: true // 是否显示付款按钮
    };
  },

  computed: {

    /**
     * 发起付款按钮能否点击的条件
     *    条件1 每次仅可选择一条付款单数据
     *    条件2 付款单状态为“待核付0、付款失败4、部分付款2”的单
     *    账单类型为邮局禁止付款
     */
    isPayBut() {
      const { selectData } = this;
      // 禁用
      if (selectData.length !== 1) {
        return true;
      }

      const { payableStatus, payableType } = selectData[0];
      // 启用
      if (PAY_STATUS.includes(payableStatus) && payableType !== 6) {
        return false;
      }

      // 禁用
      return true;
    },

    /**
     * 查询结果 按钮 启用条件
     *  条件1 仅可选择一条付款单数据
     *  条件2 付款单状态为“付款中3”的单
     */
    isResults() {
      const { selectData } = this;
      // 禁用
      if (selectData.length !== 1) {
        return true;
      }

      const { payableStatus } = selectData[0];
      // 启用
      if (payableStatus === PAYABLE_STATUS['3'].value) {
        return false;
      }

      // 禁用
      return true;
    }
  },

  created() {
    // 是否存在付款按钮权限，只有存在一个权限就会显示
    const buttonPermissions = this.$store.getters.button_permissions;
    this.isShowBut = buttonPermissions.includes('btn:payableManagement:payableCollection:InitiationPayment') || buttonPermissions.includes('btn:payableManagement:payableCollection:EnquiryResults');
  },

  methods: {
    // 打开付款
    openPayDialog() {
      console.log(this.selectData, '==selectData');
      const { providerName, billFee, id } = this.selectData[0];
      this.payForm.providerName = providerName;
      this.payForm.billFee = billFee;
      this.payForm.id = id;
      this.isPayDialog = true;
    },

    // 确认付款
    paySumbit() {
      const str1 = this.$i18n.t('GlobalSetObj.determine'); // 确定
      const str2 = this.$i18n.t('ClaimsManagement.Payment'); // 付款
      const str3 = this.$i18n.t('customerManagements.tips'); // 提示
      const str4 = this.$i18n.t('GlobalSetObj.TheOperationSucceeded'); // 操作成功
      this.$confirm(`${str1} ${str2}？`, str3, {
        confirmButtonText: str1,
        cancelButtonText: this.$i18n.t('GlobalSetObj.cancel'),
        type: 'warning'
      }).then(() => {
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // });
        const { id } = this.payForm;
        this.isLoading = true;
        return apiSitePayablePay({ id }, false);
      }).then(res => {
        this.$message.success(str4);
        console.log(res);
        this.isPayDialog = false;
        this.$emit('updatePage', true);
      }).catch(err => {
        console.error(err);

        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      }).finally(() => {
        this.isLoading = false;
      });
    },

    // asyncApiSitePayablePay(data) {
    //   return apiSitePayablePay(data).then(res => {
    //     console.log(res);
    //   }).catch(err => {
    //     console.log(err);
    //   });
    // }

    // 查询结果
    asyncApiSitePayableQuirePay() {
      const { id } = this.selectData[0];
      apiSitePayableQuirePay({ id }).then(res => {
        this.$message(this.$i18n.t('GlobalSetObj.bemSucedido'));
        this.$emit('updatePage', true);
      }).catch(err => {
        console.error(err);
      });
    }
  }

};
</script>

<style scoped>
.but {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border: 1px solid #000; */
}
.but-row {
  margin-bottom: 10px;
}

</style>
